import React from 'react';
import { Card, Grid, Table, TableBody, TableHead, TableRow, Typography } from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';

import {
  StyledTableRow,
  StyledTableCell,
  Input,
  Search,
  SearchIconWrapper,
  NoResultsWrapper,
  StyledTableContainer
} from './styles';

type SizeType = 'small' | 'medium';

interface IProps {
  title?: string;
  description?: string;
  columns?: any;
  rows?: any;
  onFilterChange?: any;
  onTableRowClick?: any;
  height?: string;
  size?: SizeType;
  children?: React.ReactNode;
}

const JwlTable: React.FC<IProps> = ({
  title,
  description,
  columns,
  rows,
  onFilterChange,
  onTableRowClick,
  height,
  size = 'medium',
  children
}: IProps) => {
  return (
    <Card style={{ padding: '8px' }}>
      <Grid container justify="space-between" alignItems="center" style={{ marginBottom: '8px' }}>
        <div>
          {title && (
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="body2" gutterBottom>
              {description}
            </Typography>
          )}
        </div>
        <div>
          {children}
          {onFilterChange && (
            <Grid item>
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <Input placeholder="Search item" onChange={onFilterChange} />
              </Search>
            </Grid>
          )}
        </div>
      </Grid>
      <StyledTableContainer height={height}>
        <Table aria-label="table" size={size} stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column: any) => {
                return <StyledTableCell key={column}>{column}</StyledTableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 &&
              rows.map((row: any) => (
                <StyledTableRow
                  key={row.id}
                  hover={Boolean(onTableRowClick)}
                  style={{
                    cursor: onTableRowClick ? 'pointer' : 'default'
                  }}
                  onClick={() => onTableRowClick && onTableRowClick(row.id)}
                >
                  {row.cells.map((rowCell: any, index: number) => {
                    return <StyledTableCell key={index}>{rowCell}</StyledTableCell>;
                  })}
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </StyledTableContainer>

      {rows.length === 0 && (
        <NoResultsWrapper>
          <Typography component="span" variant="h6" gutterBottom>
            We can't find what you're looking for!
          </Typography>
        </NoResultsWrapper>
      )}
    </Card>
  );
};

export default JwlTable;
